import axios from 'axios';
import Vue from 'vue';
import router from '@/router';

const getToken = () => (
  window.localStorage.getItem('token')
);

const httpClient = axios.create({
  baseURL: process.env.BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const isRecordNotFoundError = (message) => {
  const patterns = [
    /Record '.*' not found/,
    /Поле ".*" - число, и не может принимать .*/,
  ];
  patterns.forEach((pattern) => {
    if (pattern.test(message)) {
      const text = 'Такая запись не была найдена';
      Vue.notify({
        group: 'main', type: 'error', title: 'Ошибка!', text, duration: 3000,
      });
      router.push('/main');
    }
  })
};

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    isRecordNotFoundError(error.response.data.message);
    return Promise.reject(error);
  }
);

httpClient.interceptors.request.use((config) => {
  config.headers['X-Authorization'] = `Bearer ${getToken()}`;
  return config;
});

export default httpClient;



// WEBPACK FOOTER //
// ./src/http-common.js